import { render } from "./MobileDeansListModal.vue?vue&type=template&id=6890b7ea&scoped=true"
import script from "./MobileDeansListModal.vue?vue&type=script&lang=js"
export * from "./MobileDeansListModal.vue?vue&type=script&lang=js"

import "./MobileDeansListModal.vue?vue&type=style&index=0&id=6890b7ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6890b7ea"]])

export default __exports__